import { Component, ViewChild } from '@angular/core';
import { Events, Tabs } from 'ionic-angular';
//import { IonicPage, NavController } from 'ionic-angular';
//import { HomePage } from '../home/home';

//@IonicPage()
@Component({
  selector: 'page-pc-tabs',
  templateUrl: 'pc-tabs.html'
})
export class PcTabsPage {
  encargadosRoot = 'EncargadosPage'
  partesRoot = 'PartesPage'
  personalRoot = 'PersonalPage'
  tareasRoot = 'TareasPage'
  ajustesRoot = 'AjustesPage'
  @ViewChild('myTabs') tabRef: Tabs;
    constructor(public events: Events) {
      events.subscribe('tab:clicked', (data) => 
      {
        this.tabRef.select(data['tab']);
      });
    }

}



// WEBPACK FOOTER //
// ./src/pages/pc-tabs/pc-tabs.ts